import AppConstants from "@/AppConstants.js";
/* -- */
export default {
  namespaced: true,
  state: {
    mode: AppConstants.CONFIG_MODE,
    /* --- */
    configMsg: {},
    ctrlmode: "253",
    configMode: "0",
    progress: "0",
    updateCounter: 0,
    statusPage: 1,
    volumeArray: [0, 0, 0, 0, 0, 0, 0, 0, 0],
    sequenceArray: [0, 0, 0, 0, 0, 0, 0, 0, 0],
    mediaArray: [0, 0, 0, 0, 0, 0, 0, 0, 0],
    sequenceFileArray: [{ value: 0, size: 0, text: "" }],
    mediaFileArray: [{ value: 0, size: 0, text: "" }],
    ctrlmodes: [],
    registrationStatus: "",
  },
  getters: {
    getMode: (state) => {
      return state.mode;
    },
    getCtrlMode: (state) => {
      return state.ctrlmode;
    },
    getProgress: (state) => {
      return state.progress;
    },
    getConfigMode: (state) => {
      return state.configMode;
    },
    getCtrlModes: (state) => {
      if (AppConstants.CONFIG_PRIMARY_MODE == state.mode) {
        /* Primary mode */
        state.ctrlmodes = [
          { value: 255, text: "Basic" },
          { value: 253, text: "Advanced" },
          { value: 252, text: "DDP" },
        ];
      } else if (AppConstants.CONFIG_INSTALLATION_MODE == state.mode) {
        state.ctrlmodes = [{ value: 255, text: "Basic" }];
      } else if (AppConstants.CONFIG_REGISTRATION_MODE == state.mode) {
        state.ctrlmodes = [{ value: 255, text: "Basic" }];
      }
      return state.ctrlmodes;
    },
    getRegistrationStatus: (state) => {
      return state.registrationStatus;
    },
    getUpdateCounter: (state) => {
      return state.updateCounter;
    },
    getSequenceFiles: (state) => {
      return state.sequenceFileArray;
    },
    getMediaFiles: (state) => {
      return state.mediaFileArray;
    },
    getSequenceByIndex: (state) => (index) => {
      return state.sequenceArray[index - 1];
    },
    getSequenceFileByIndex: (state) => (index) => {
      let sequenceFileArrayIndex = state.sequenceArray[index - 1];
      return state.sequenceFileArray[sequenceFileArrayIndex].text;
    },
    getMediaByIndex: (state) => (index) => {
      return state.mediaArray[index - 1];
    },
    getMediaFileByIndex: (state) => (index) => {
      let mediaFileArrayIndex = state.mediaArray[index - 1];
      return state.mediaFileArray[mediaFileArrayIndex].text;
    },
    getVolumeByIndex: (state) => (index) => {
      return state.volumeArray[index - 1];
    },
    getStatusPage: (state) => {
      return state.statusPage;
    },
  },
  mutations: {
    setConfigMsg: (state, val) => {
      state.configMsg = val;
      if (Object.prototype.hasOwnProperty.call(state.configMsg, "ctrlmode")) {
        state.ctrlmode = state.configMsg.ctrlmode;
      }
      if (Object.prototype.hasOwnProperty.call(state.configMsg, "configMode")) {
        state.configMode = state.configMsg.configMode;
      }
      if (Object.prototype.hasOwnProperty.call(state.configMsg, "progress")) {
        state.progress = state.configMsg.progress;
      }
      if (
        Object.prototype.hasOwnProperty.call(state.configMsg, "volumeArray")
      ) {
        state.volumeArray = [];
        for (let i = 0; i < state.configMsg.volumeArray.length; i++) {
          state.volumeArray[i] = state.configMsg.volumeArray[i];
        }
      }
      if (
        Object.prototype.hasOwnProperty.call(state.configMsg, "sequenceArray")
      ) {
        state.sequenceArray = [];
        for (let i = 0; i < state.configMsg.sequenceArray.length; i++) {
          state.sequenceArray[i] = state.configMsg.sequenceArray[i];
        }
        if (
          Object.prototype.hasOwnProperty.call(
            state.configMsg,
            "sequenceFileArray"
          )
        ) {
          state.sequenceFileArray = [];
          for (let i = 0; i < state.configMsg.sequenceFileArray.length; i++) {
            state.sequenceFileArray[i] = {
              value: i,
              size: 0,
              text: state.configMsg.sequenceFileArray[i],
            };
          }
        }
      }
      if (Object.prototype.hasOwnProperty.call(state.configMsg, "mediaArray")) {
        state.mediaArray = [];
        for (let i = 0; i < state.configMsg.mediaArray.length; i++) {
          state.mediaArray[i] = state.configMsg.mediaArray[i];
        }
        if (
          Object.prototype.hasOwnProperty.call(
            state.configMsg,
            "mediaFileArray"
          )
        ) {
          state.mediaFileArray = [];
          for (let i = 0; i < state.configMsg.mediaFileArray.length; i++) {
            state.mediaFileArray[i] = {
              value: i,
              size: 0,
              text: state.configMsg.mediaFileArray[i],
            };
          }
        }
        if (
          Object.prototype.hasOwnProperty.call(
            state.configMsg,
            "mediaFileSizeArray"
          )
        ) {
          for (let i = 0; i < state.configMsg.mediaFileSizeArray.length; i++) {
            state.mediaFileArray[i].size =
              state.configMsg.mediaFileSizeArray[i];
            if (i) {
              if (0 == state.mediaFileArray[i].size) {
                state.mediaFileArray[i].text =
                  "(?) " + state.mediaFileArray[i].text;
              }
            }
          }
        }
        if (
          Object.prototype.hasOwnProperty.call(
            state.configMsg,
            "sequenceFileSizeArray"
          )
        ) {
          for (
            let i = 0;
            i < state.configMsg.sequenceFileSizeArray.length;
            i++
          ) {
            state.sequenceFileArray[i].size =
              state.configMsg.sequenceFileSizeArray[i];
            if (i) {
              if (0 == state.sequenceFileArray[i].size) {
                state.sequenceFileArray[i].text =
                  "(?) " + state.sequenceFileArray[i].text;
              }
            }
          }
        }
      }
      state.updateCounter++;
    },
    setSequence: (state, val) => {
      state.sequenceArray[val.index - 1] = val.value;
      if (AppConstants.CONFIG_MQTT_DEBUG_MODE) {
        // eslint-disable-next-line
        console.log("index "+(val.index - 1)+" value " + val.value);
        // eslint-disable-next-line
        console.log(state.sequenceArray);
      }
    },
    setMedia: (state, val) => {
      state.mediaArray[val.index - 1] = val.value;
    },
    setVolume: (state, val) => {
      state.volumeArray[val.index - 1] = val.value;
    },
    setStatusPage: (state, val) => {
      state.statusPage = val;
    },
    setRegistrationStatus: (state, val) => {
      state.registrationStatus = val;
    },
    setConfigMode: (state, val) => {
      state.configMode = val;
    },
  },
  actions: {},
};
